import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import MaintenanceHistoryView from '../components/MaintenanceHistoryView';
import CsvMenu from '../components/CsvMenu';
import HeaderMenu from '../components/HeaderMenu';

const MaintenanceHistory = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const isAdmin = user.role === 'admin' || user.role === 'technician';

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-wrap justify-between items-center gap-2">
            <Button
              variant="outline"
              onClick={() => navigate('/')}
              data-testid="back-to-dashboard-btn"
            >
              ← Back to Dashboard
            </Button>
            <div className="flex gap-2 items-center">
              <CsvMenu
                exportPath="/maintenance-history/export.csv"
                templatePath="/maintenance-logs/import-template.csv"
                importPath="/maintenance-logs/import"
                kind="history"
                dialogTitle="Import Maintenance Logs CSV"
                dialogDescription="Each row becomes a new maintenance log. Equipment is matched by name — unmatched rows are rejected in the preview. (Note: work orders and requests cannot be imported this way — they must be created individually.)"
                canImport={isAdmin}
                testIdPrefix="history"
              />
              <HeaderMenu user={user} onLogout={onLogout} />
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <MaintenanceHistoryView
          user={user}
          title="Maintenance History"
          subtitle="Plant-wide activity — maintenance logs, completed work orders, and completed maintenance requests."
        />
      </div>
    </div>
  );
};

export default MaintenanceHistory;
